import {DialogContent, DialogTitle, Typography} from '@material-ui/core';
import {makeStyles, Theme} from '@material-ui/core/styles';
import React from 'react';

// import contactIcon from '../../assets/contact-blue.svg';
import {colors} from '../../theme/theme';

import {Call} from '@material-ui/icons';
import ButtonClose from '../ButtonClose/ButtonClose';
import {AppState, SalesType} from "../../types/redux";
import {useSelector} from "react-redux";

const useStyles = makeStyles((theme: Theme) => ({
	phoneBtn: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		textDecoration: 'none',
		padding: theme.spacing(3, 0),
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(4, 0),
		},
	},

	openingHours: {
		color: colors.grayA50,
	},
	quickMenu: {
		position: 'fixed',
		top: 77,
		right: 0,
		backgroundColor: colors.white,
		zIndex: theme.zIndex.modal,
	},

	btnIcon: {
		width: '100%',
		height: '100%',
		color: theme.palette.primary.main,
		'&.is-active': {
			color: colors.grayA50,
		},
	},

	dialogTitle: {
		padding: theme.spacing(2, 4, 2),
		backgroundColor: theme.palette.grey[100],
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(4, 6, 2),
		},
	},
	dialogContent: {
		padding: theme.spacing(0, 4, 2),
		[theme.breakpoints.up('sm')]: {
			padding: theme.spacing(1, 6, 4),
		},
	},
}));

export const ContactDialogContent: React.FC<{ handleClose(): void }> = ({
	handleClose,
}) => {
	const classes = useStyles();

	const salesTypes = useSelector<AppState, SalesType[]>( state => state.user.salesType );

	const isEp = salesTypes.includes(SalesType.EPK) || salesTypes.includes(SalesType.EPH);
	return (
		<>
			<DialogTitle
				id="quick-menu-dialog"
				disableTypography={true}
				className={classes.dialogTitle}
			>
				<Typography variant="h2">Service-Hotline</Typography>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<Typography variant="h4">
					Haben Sie Fragen zum Versicherungsprodukt, zum Vertrag oder zur
					Online-Antragsstrecke? Unsere Service-Mitarbeiter helfen Ihnen gerne
					direkt weiter:
				</Typography>
				{ !isEp && <a className={classes.phoneBtn} href="tel:0213120107130">
					<Typography
						variant={'h2'}
						color="primary"
						style={{ display: 'flex', alignItems: 'center' }}
					>
						<Call style={{ fontSize: '120%', marginRight: 4 }} /> 02131 2010 7130
					</Typography>
				</a> }
				{ isEp && <a className={classes.phoneBtn} href="tel:0213120107120">
					<Typography
						variant={'h2'}
						color="primary"
						style={{ display: 'flex', alignItems: 'center' }}
					>
						<Call style={{ fontSize: '120%', marginRight: 4 }} /> 02131 2010 7120
					</Typography>
				</a> }
				<Typography variant="h4" className={classes.openingHours}>
					Mo. - Fr. von 08:00 bis 18:00 Uhr
				</Typography>
				{ isEp &&
					<Typography variant="h4" className={classes.openingHours}>
						Weitere Informationen finden Sie auch unter <a rel="noopener noreferrer" href="https://www.bank11.de/evoprotect/" target="_blank">https://www.bank11.de/evoprotect/</a>
					</Typography>
				}
			</DialogContent>
			<ButtonClose onClick={handleClose} />
		</>
	);
};
